import {DataFetcher, PriorityConfig} from '@aboutyou/data-fetcher';
import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';
import {useGetBrandHubHeader} from '../utils/useGetBrandHubHeader';
import {
  BrandHubGenderSwitchView,
  BrandHubGenderSwitchViewProps,
} from './BrandHubGenderSwitchView';

export const BrandHubGenderSwitch: React.FC<
  PriorityConfig & BrandHubGenderSwitchViewProps
> = ({renderingPriority, ...otherProps}) => {
  return (
    <DataFetcher
      request={useGetBrandHubHeader()}
      Error={() => null}
      Loading={BrandHubGenderSwitchLoading}
      View={BrandHubGenderSwitchView}
      viewProps={otherProps}
      renderingPriority={renderingPriority}
    />
  );
};

const BrandHubGenderSwitchLoading: React.FC = () => {
  return <SkeletonBlock $width="100%" $height="36px" />;
};
